import { createIconComponent } from '../../factory/create-icon-component';
export const UnassortedItemIcon = createIconComponent(
  'UnassortedItemIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00076 3.99957C6.00076 5.10414 5.10533 5.99957 4.00076 5.99957C2.89619 5.99957 2.00076 5.10414 2.00076 3.99957C2.00076 2.895 2.89619 1.99957 4.00076 1.99957C5.10533 1.99957 6.00076 2.895 6.00076 3.99957Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="4.00076"
      cy="19.9996"
      r="2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="12.0008"
      cy="3.99957"
      r="2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="12.0008"
      cy="11.9996"
      r="2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="4.00076"
      cy="11.9996"
      r="2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0008 21.9996C10.8962 21.9996 10.0008 21.1041 10.0008 19.9996C10.0008 19.2596 10.4026 18.6135 11 18.2676"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.0007 11.9996C22.0007 10.8951 21.1053 9.99963 20.0007 9.99963C18.8962 9.99963 18.0007 10.8951 18.0007 11.9996"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="20.0007"
      cy="3.99957"
      r="2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 22L22 16M16 16L22 22"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
